import { render, staticRenderFns } from "./dan.vue?vue&type=template&id=0198388e&scoped=true&"
import script from "./dan.vue?vue&type=script&lang=js&"
export * from "./dan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198388e",
  null
  
)

export default component.exports